import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'
import { COOKIE_CONSENT_EVENT, hasAnalyticsConsent } from '@/lib/consent'
import { registerPwaServiceWorker, setupPwaInstallPromptListener } from '@/lib/pwa'

// Restore dark mode preference
if (localStorage.getItem("theme") === "dark") {
  document.documentElement.classList.add("dark");
}

const startObservability = () => {
  Promise.all([
    import("@/lib/monitoring"),
    import("@/lib/analytics"),
  ]).then(([monitoring, analytics]) => {
    monitoring.initMonitoring();
    analytics.initAnalytics();
  });
};

if (hasAnalyticsConsent()) {
  startObservability();
}

setupPwaInstallPromptListener();
registerPwaServiceWorker();

window.addEventListener(COOKIE_CONSENT_EVENT, (event) => {
  if (event.detail === "accepted") {
    startObservability();
  }
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
)
